import { p as parseCookies, g as getRootDomain, s as setCookieValue } from "../../../cookies-04bd2321.js";
import { EVENT_FIELDS } from "../../constants/analytics.es.js";
import { logger } from "../../../utils/logger.es.js";
import { v as v4 } from "../../../v4-88c20f3b.js";
const getBrowserID = ({ req = {}, res = {}, passedUUID = null } = {}) => {
  try {
    const { browser_id: browserId } = parseCookies(req);
    if (browserId) {
      return browserId;
    }
    const newBrowserId = passedUUID || v4();
    let rootDomain;
    if (typeof window !== "undefined") {
      rootDomain = getRootDomain(window.location.hostname);
    } else if (req.headers.host) {
      rootDomain = getRootDomain(req.headers.host);
    }
    setCookieValue(
      EVENT_FIELDS.BROWSER_ID,
      newBrowserId,
      {
        ...rootDomain && { domain: rootDomain },
        maxAge: 36525 * 24 * 60 * 60,
        sameSite: "strict"
      },
      res
    );
    return newBrowserId;
  } catch (error) {
    logger.error("Error generating browser ID:", error);
  }
};
export {
  getBrowserID
};
